import Client from '../axiosClient'
const resource = '/booking';
const resourceEmail = '/booking-email';
const resourceInit = '/booking_initialize';
const resourceStatusId = '/booking_by_status_id';
const resourcegeneratePdf = '/pdf';
const resourcecommunication =  '/communication';
const resourcebookingstatement =  '/booking_pdf';
const BOOKING_INIT = '/customer/tour_brochure/booking_initialize';
const GET_PRICE_BY_PAX = '/customer/book_brochure/get_price_by_pax';
const VARIANT_PRICE = '/customer/tour_brochure/filter_price';
const POST_BOOKING = '/customer/tour_brochure/booking_request';
const POST_BOOKING_EDIT = '/customer/tour_brochure/booking_request_edit';
const BOOKING_BY_ID = '/customer/tour_brochure/get_booking_by_id';
const ConfirmSecret = '/booking-confirm';
const ConfirmUpdateSecret = '/edit-booking-confirm';
const createInvoice = '/invoices';
const createPaidPartner = '/bookingP/paidtopartner';
const RemainingPaymentRequest = '/customer/book_brochure/remaining-payment-request';


const editBookingCode = 'edit_booking_code';

export default {
  init(partnerId='') {
    let reqUrl = resourceInit;
    if(partnerId !=''){
      reqUrl += '?partnerId='+partnerId
    }
    return Client.get(`${reqUrl}`);
  },


  editBookingCode(payload){
    return Client.post(`${editBookingCode}`, payload);
  },

  
  bookingInit(qString="") {
    let url = BOOKING_INIT;
    if(qString !=""){
      url = url+"?"+qString;
    }
    return Client.get(`${url}`);
  },
  get() {
    return Client.get(`${resource}`);
  },


  getBookingStatement(id) {
    console.log("idaa",id);
    return Client.get(`${resourcebookingstatement}/${id}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  pdf(id) {
    return Client.get(`${resourcegeneratePdf}/${id}`);
  },

  getByStatusId (payload) {
    return Client.post(`${resourceStatusId}`, payload);
  },
  
  post(payload) {
    return Client.post(`${resource}`, payload);
  },
  sendEmail(payload) {
    return Client.post(`${resourceEmail}`, payload);
  },

  communication(payload){
    return Client.post(`${resourcecommunication}`, payload);
  },
  
  postPriceByPax(payload) {
    return Client.post(`${GET_PRICE_BY_PAX}`, payload);
  },
  postPriceByVariant(payload) {
    return Client.post(`${VARIANT_PRICE}`, payload);
  },
  
  postBooking(payload) {
    return Client.post(`${POST_BOOKING}`, payload);
  },

  postBookingEdit(payload) {
    return Client.post(`${POST_BOOKING_EDIT}`, payload);
  },
  
  getBookingById(payload){    
    return Client.post(`${BOOKING_BY_ID}`, payload);
  },
  confirmSecret(payload){    
    return Client.post(`${ConfirmSecret}`, payload);
  },
  confirmUpdateSecret(payload){    
    return Client.post(`${ConfirmUpdateSecret}`, payload);
  },
  createInvoice(payload){    
    return Client.post(`${createInvoice}`, payload);
  },
  createPaidPartner(payload){    
    return Client.post(`${createPaidPartner}`, payload);
  },
  remainingPaymentRequest(payload){
    return Client.post(`${RemainingPaymentRequest}`, payload);
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/travel/bookingRepository.js